export default __webpack_public_path__ + "static/media/Python-django.550fd43d.svg";